import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from 'firebase/analytics';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

// Your Firebase configuration - Updated for current project
const firebaseConfig = {
  apiKey: "AIzaSyBXhfbLtTF63vvR9CoIE6MhT4cW01aJGs0",
  authDomain: "islandrentals-bca69.firebaseapp.com", 
  databaseURL: "https://islandrentals-bca69-default-rtdb.firebaseio.com",
  projectId: "islandrentals-bca69",
  storageBucket: "islandrentals-bca69.firebasestorage.app",
  messagingSenderId: "527273086354",
  appId: "1:527273086354:web:58e2cfffdb023b8aaf454b",
  measurementId: "G-DZ9FBDEDLB"
};

// Initialize Firebase (safe initialization)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

// Initialize Storage
export const storage = getStorage(app);

// Initialize Analytics (only in browser environment and with valid config)
export const analytics = typeof window !== 'undefined' && process.env.NODE_ENV === 'production' ? getAnalytics(app) : null;

// Initialize App Check (only in production with valid key)
export const appCheck = typeof window !== 'undefined' && process.env.NODE_ENV === 'production' && process.env.REACT_APP_RECAPTCHA_SITE_KEY ? initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
  isTokenAutoRefreshEnabled: true
}) : null;

export default app;
